import { useTranslation } from "react-i18next";
import { Megaphone } from "@phosphor-icons/react";
import { useAuth } from "../../contexts/AuthContext";
import PortalEmptyState from "../../components/portal/PortalEmptyState";

export const PortalHome = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  if (!user) return null;

  const firstName = user.first_name || user.email.split("@")[0];

  return (
    <div data-testid="portal-home" className="space-y-10">
      <header>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
          {t("portal.home.kicker")}
        </p>
        <h1 className="mt-3 font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
          {t("portal.home.welcome", { name: firstName })}
        </h1>
        <p className="mt-3 text-sm md:text-base text-slate-600 max-w-xl">
          {t("portal.home.subtitle")}
        </p>
      </header>

      <section data-testid="portal-announcements">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl adonis-gradient">
              <Megaphone size={18} weight="light" className="text-white" />
            </span>
            <div>
              <h2 className="font-heading text-lg md:text-xl font-bold tracking-tight text-slate-900">
                {t("portal.home.announcements_title")}
              </h2>
              <p className="text-xs text-slate-500">
                {t("portal.home.announcements_subtitle")}
              </p>
            </div>
          </div>
        </div>

        <PortalEmptyState
          variant="dashed"
          testId="announcements-empty"
          titleKey="portal.home.announcements_empty_title"
          descKey="portal.home.announcements_empty_desc"
        />
      </section>
    </div>
  );
};

export default PortalHome;
